import React from 'react';
import {
  LogType,
  LogName,
  LogDisplayName,
} from '@oxappsec/ox-unified-audit-logger';
import {
  MdApps as AppsIcon,
  MdLogin as LoginIcon,
  MdLogout as LogoutIcon,
  MdOutlineLogin as LoginOptionsIcon,
  MdCheckCircle as CheckIcon,
  MdOutlineRemoveCircle as RemoveIcon,
  MdPersonRemoveAlt1 as UserRemoveIcon,
  MdPersonAddAlt1 as UserAddIcon,
  MdOutlineAdminPanelSettings as UserRoleIcon,
  MdDeleteOutline as DeleteOutlineIcon,
  MdOutlineGroups as MembersIcon,
} from 'react-icons/md';
import {
  CgPlayStopO as StopIcon,
  CgPlayButtonO as PlayIcon,
} from 'react-icons/cg';
import { BsUpcScan as ScanIcon } from 'react-icons/bs';
import { FaUserLock as AuthIcon } from 'react-icons/fa';
import {
  FilterType,
  FilterTypeSearch,
  FilterTypeToFilter,
} from '../../common/filters-utils/filters-utils';

const logTypeIconMap: Record<LogType, IconColorTuple> = {
  Connectors: { icon: AppsIcon, color: 'blue' },
  Scan: { icon: ScanIcon, color: 'blue' },
  Authentication: { icon: AuthIcon, color: 'blue' },
  Login: { icon: LoginIcon, color: 'blue' },
  LoginOptions: { icon: LoginOptionsIcon, color: 'blue' },
  Members: { icon: MembersIcon, color: 'blue' },
};

const logNameIconMap: Record<LogName, IconColorTuple> = {
  AddCredentials: { icon: CheckIcon, color: 'green' },
  RemoveCredentials: { icon: RemoveIcon, color: 'red' },
  EnableConnector: { icon: CheckIcon, color: 'green' },
  DisableConnector: { icon: RemoveIcon, color: 'red' },
  ScanNow: { icon: PlayIcon, color: 'blue' },
  CancelScan: { icon: StopIcon, color: 'red' },
  AddLoginOption: { icon: CheckIcon, color: 'green' },
  RevokeLoginOption: { icon: StopIcon, color: 'red' },
  UpdateLoginOption: { icon: StopIcon, color: 'blue' },
  SendInvitation: { icon: UserAddIcon, color: 'green' },
  RevokeInvitation: { icon: UserRemoveIcon, color: 'red' },
  ResendInvitation: { icon: UserAddIcon, color: 'green' },
  MemberAcceptInvitation: { icon: StopIcon, color: 'green' },
  RemoveMember: { icon: DeleteOutlineIcon, color: 'red' },
  UpdateMemberRoles: { icon: UserRoleIcon, color: 'blue' },
  Login: { icon: LoginIcon, color: 'blue' },
  Logout: { icon: LogoutIcon, color: 'blue' },
};

export const resolveLogTypeIcon = (logType: LogType) => {
  const logTypeIcon = logTypeIconMap[logType];
  if (!logTypeIcon) {
    return null;
  }

  const { icon, color } = logTypeIcon;

  return React.createElement(icon, { fontSize: 20, color });
};

export const resolveLogNameIcon = (logName: LogName) => {
  const logNameIcon: IconColorTuple = logNameIconMap[logName];
  if (!logNameIcon) {
    return null;
  }

  const { icon, color } = logNameIcon;
  return React.createElement(icon, {
    fontSize: 20,
    color,
  });
};

export const getLogDisplayName = (logName: LogName) => {
  return LogDisplayName[logName] || logName;
};

interface IconColorTuple {
  icon: React.FunctionComponent<
    React.PropsWithChildren<
      React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
      }
    >
  >;
  color: string;
}

export const filterTypes = [
  {
    type: FilterTypeToFilter.logNames,
    header: FilterType.logNames,
    searchType: FilterTypeSearch.logNames,
  },
  {
    type: FilterTypeToFilter.userEmails,
    header: FilterType.userEmails,
    searchType: FilterTypeSearch.userEmails,
  },
  {
    type: FilterTypeToFilter.logTypes,
    header: FilterType.logTypes,
    searchType: FilterTypeSearch.logTypes,
  },
];
